import React from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './CloudflareConfirmModal.styles';

const CloudflareConfirmModal = ({
  onClose,
  icon,
  testId = 'cloudflare-confirm-modal',
  title = 'modal title',
  message = '',
  primaryButtonLabel = 'primary button label',
  buttonAction,
  secondaryButtonLabel = ' secondary button label',
  loading,
}) => {
  const handleOnClose = () => {
    onClose && onClose();
  };

  const handlePrimaryAction = () => {
    buttonAction && buttonAction();
  };

  return (
    <Modal onClose={handleOnClose} maxWidth={502} testId={testId}>
      <Styles.Wrapper>
        {icon && icon}
        {title && <Styles.Title>{title}</Styles.Title>}
        {message && <Styles.Message>{message}</Styles.Message>}

        <Styles.ButtonContainer>
          <Button
            variant="secondary"
            label={secondaryButtonLabel}
            onClick={handleOnClose}
            size="large"
            disabled={loading}
          />

          <Button
            label={primaryButtonLabel}
            onClick={handlePrimaryAction}
            size="large"
            loading={loading}
            disabled={loading}
          />
        </Styles.ButtonContainer>
      </Styles.Wrapper>
    </Modal>
  );
};

export default CloudflareConfirmModal;
